// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__38SZg","upload":"Small_upload__3UL0F","imageWrap":"Small_imageWrap__38B0e","removeBtn":"Small_removeBtn__2Jkkq"};